export default __webpack_public_path__ + "static/media/Dates_Supprimer.1e57bcf3.png";